import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Collapse, Divider, Modal, Table, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
const DocComments = ({ open, onClose, data, lstCmts, handleInputChange, question, submitDocCommentQuery }) => {
    var _a;
    const columns = [
        {
            title: 'Date/Time',
            dataIndex: 'dtCommentDate',
            key: '1'
        },
        {
            title: 'Source',
            dataIndex: 'strSourceName',
            key: '2'
        },
        {
            title: 'Provided By',
            dataIndex: 'strCommentByName',
            key: '3'
        },
        {
            title: 'Comments',
            dataIndex: 'strCommentDesc',
            key: '4'
        }
    ];
    const items = [
        {
            key: '1',
            label: _jsx("div", { style: { fontWeight: 'bold' }, children: "View Comment History" }),
            children: (_jsx(Table, { columns: columns, dataSource: lstCmts.map((item, index) => (Object.assign(Object.assign({}, item), { key: index }))) }))
        }
    ];
    return (_jsxs(Modal, { title: ((_a = data === null || data === void 0 ? void 0 : data.objDocumentType) === null || _a === void 0 ? void 0 : _a.strLongDesc) + ' - Comment', width: 1000, open: open, onCancel: onClose, footer: null, children: [_jsx(Typography.Title, { level: 5, children: "Enter Comments for BV" }), _jsx(TextArea, { rows: 4, maxLength: 2000, placeholder: "Please enter the question", value: question, onChange: (e) => handleInputChange && handleInputChange('docComments', e.target.value) }), _jsxs("div", { children: ["Maximum allowed Characters: ", 2000 - ((question === null || question === void 0 ? void 0 : question.length) || 0), "/2000 (remaining)"] }), _jsx(Button, { type: "primary", onClick: () => submitDocCommentQuery && submitDocCommentQuery(data), disabled: !question, children: "Submit" }, "submit"), _jsx(Divider, {}), _jsx(Collapse, { defaultActiveKey: ['1'], items: items, bordered: false, expandIcon: ({ isActive }) => (isActive ? _jsx(MinusSquareOutlined, {}) : _jsx(PlusSquareOutlined, {})) })] }));
};
export default DocComments;
